<template>
  <div class="container">
    <my-terminal :id="id" ref="myTerminal"></my-terminal>
  </div>
</template>

<script>
import Console from './Console'

export default {
  name: 'WebSSH',
  components: {
    'my-terminal': Console
  },
  props: {
    id: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      msg: 'test',
      username: 'test',
      password: 'test'
    }
  },
  methods: {
    handleClose() {
      this.$refs.myTerminal.closeRealTerminal()
    },
    handleConnect() {
      this.$refs.myTerminal.initTerminal()
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  height: 100%;
}
</style>
